import { render } from "./IntroductionScreen.vue?vue&type=template&id=c9232db4&scoped=true"
import script from "./IntroductionScreen.vue?vue&type=script&lang=js"
export * from "./IntroductionScreen.vue?vue&type=script&lang=js"

import "./IntroductionScreen.vue?vue&type=style&index=0&id=c9232db4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9232db4"]])

export default __exports__